"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
class Config {
    static config;
}
exports.Config = Config;
//# sourceMappingURL=index.js.map